// extracted by mini-css-extract-plugin
module.exports = {"entryLink":"index-module--entryLink--3RleZ","entryTitle":"index-module--entryTitle--37eS4","entryDate":"index-module--entryDate--FZSph"};